module.exports = __webpack_public_path__ + "img/ethicalDashboard.5f7dc693.png";